import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider } from "styled-components";
import {
  Container,
  Row,
  Col,
  Button,
  Jumbotron,
  Card,
  Modal,
  Table
} from "react-bootstrap";
import { TicketTable } from "../../components/ticket-table/TicketTable.comp";
import { Pagination } from "../../components/pagination/pagination";
import tickets from "../../assets/data/dummy-tickets.json";
import { PageBreadcrumb } from "../../components/breadcrumb/Breadcrumb.comp";
import { Link } from "react-router-dom";
import ChatBot from "react-simple-chatbot";

import { fetchAllTickets } from "../ticket-list/ticketsAction";
import { getAllUsers } from "./userAction";
import "./Dashboard.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { GrAdd, GrLogin } from "react-icons/gr";
import { FaListAlt } from "react-icons/fa";
import { AiFillPlusSquare } from "react-icons";
import axios from "axios";
import { SiSlack } from "react-icons/si";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Dashboard = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [ticketmodalShow, setTicketModalShow] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [value, onChange] = useState(new Date());
  const [calendar, setCalendar] = useState(false);
  const [date, setDate] = useState();
  const [latestOpen, setLatestOpen] = useState(null);
  const [allCustomers, setAllCustomers] = useState([]);
  const [isrendered,setisrendered]=useState(false);
  const [allTickets, setAllTickets] = useState([]);
  const [ticketListforUser, setTicketListforUSer] = useState([]);
  const [customerId, setcustomerId] = useState("");
  const [latestClosed, setLatestClosed] = useState(null);
  const dispatch = useDispatch();
  const { tickets } = useSelector((state) => state.tickets);
  const { user } = useSelector((state) => state.user);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);
  const [toggle, setToggle] = useState(false);
//console.log(tickets);
  useEffect(() => {
    if (!tickets.length) {
      dispatch(fetchAllTickets());
    }
    getLatestTickets();
  }, [tickets, dispatch, date]);

  const getCustomerUrl = "https://repairs.incosa.io/v1/user/all";
  const accessJWT = sessionStorage.getItem("accessJWT");
//Get all Customers 

  useEffect(() => {
    axios
      .get(getCustomerUrl, {
        headers: {
          Authorization: accessJWT,
        },
      })
      .then((response) => {
        console.log(response.data.data);

        setAllCustomers(response.data.data);
      })
      .catch((error) => console.log(error));
  }, []);
  var totalCustomerTickets=0,totalCustomerPending=0;

allCustomers.forEach(Customer => {
  totalCustomerTickets = totalCustomerTickets + Customer.tickets.length;
  totalCustomerPending = totalCustomerPending + Customer.open;
});
 

  toast.configure();

  const notify = () => {
    toast.dark("Workspace successfully synced!");
  };

  let currentDate = new Date();
  let time =
    currentDate.getHours() +
    ":" +
    currentDate.getMinutes() +
    ":" +
    currentDate.getSeconds();
  const pendingTickets = tickets.filter((row) => row.status !== "Closed");
  const totalTickets = tickets.length;




  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = allCustomers.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const nPages = Math.ceil(allCustomers.length / recordsPerPage);

  const openTickets = tickets.filter(
    (row) => row.status !== "Pending operator response"
  );
  
  const ShowTable = (props) => {
    setTicketListforUSer(props.tickets);
    setcustomerId(props.user._id);
    setTicketModalShow(true);
  };


   
  const getLatestTickets = async () => {
    const latestTickets = { tickets };

    // let closedTickets = [];

    // for (const tkt in latestTickets.tickets) {
    //   if (latestTickets.tickets[tkt].status === "Closed") {
    //     closedTickets.push(latestTickets.tickets[tkt]);
    //   }
    // }
    // const lastClosed = closedTickets[0];
    setLatestClosed(tickets[0]);
  };

  function TicketModal(props) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header id="modalCustom" closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            All Tickets
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TicketTable redirect="dash" />
        </Modal.Body>
        <Modal.Footer id="modalCustom">
          <Button variant="outline-light" onClick={props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  function ShowTicketsForCustomer(props) {
    
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header id="modalCustom" closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            All Tickets
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#Ticket ID</th>
                <th>Customer Name</th>
                <th>Status</th>
                <th>Opened Date</th>
              </tr>
            </thead>
            <tbody>
              {props.ticketList.length ? (
                props.ticketList.map((row, index) => (
                  <tr key={row._id}>
                    <td style={{ display: "flex" }}>
                      <Link to={`/ticket/${row._id}`}>{row._id}</Link>
                    </td>

                    <td>
                      <div>{row.customerName}</div>
                    </td>
                    {row.status === "Closed" ? (
                      <td style={{ backgroundColor: "#93CA5B" }}>
                        {row.status}
                      </td>
                    ) : (
                      <td style={{ backgroundColor: "#FF9DA2" }}>
                        {row.status}
                      </td>
                    )}
                    <td>
                      {row.openAt && new Date(row.openAt).toLocaleString()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No ticket to show{" "}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer id="modalCustom">
          <Button variant="outline-light" onClick={props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <>
      <Container>
        <Jumbotron id="jumbotron">
          <h3>Welcome </h3>
          <p>
            Log new tickets, view your ticket stats and sync to workspaces live
            from Dashboard!
          </p>
        </Jumbotron>

        <Row>
          <Col>
            <PageBreadcrumb page="Dashboard" />
          </Col>
        </Row>

        {user.role === "Admin" ? (
          <>
            <Row style={{ justifyContent: "center" }}>
              <div id="dashboardCards">
                <Col>
                  <Card id="dashboardCard" border="dark">
                    <Card.Body>
                      <Card.Title>Total tickets:</Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        Total Log Count
                      </Card.Subtitle>
                      <Card.Text>{totalCustomerTickets}</Card.Text>
                    </Card.Body>
                  </Card>
                  <Card id="dashboardCard" border="dark">
                    <Card.Body>
                      <Card.Title>Pending tickets:</Card.Title>
                      <Card.Subtitle className="mb-2 text-muted">
                        Unresolved
                      </Card.Subtitle>
                      <Card.Text>{totalCustomerPending}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card id="dashboardCard" border="dark">
                    <Card.Body>
                      <Card.Title>Add New Ticket:</Card.Title>

                      <Card.Text>
                        <Link to="/add-ticket">
                          {" "}
                          <Button
                            variant="outline-light"
                            style={{ float: "right", paddingBottom: "5px" }}
                          >
                            {"  "}Add
                          </Button>
                        </Link>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                  <Card id="dashboardCard" border="dark">
                    <Card.Body>
                      <Card.Title>View Ticket table:</Card.Title>

                      <Card.Text>
                        <Button
                          onClick={() => setModalShow(true)}
                          variant="outline-light"
                          style={{ float: "right" }}
                        >
                          {"  "} View
                        </Button>

                        <TicketModal
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                        />
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </div>
            </Row>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Opened</th>
                  <th>Closed</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.map(function(singleCustomer) {
                  let customerId = singleCustomer.user._id;
                  return (
                    <>
                      <tr
                        key={singleCustomer.open}
                        onClick={() => ShowTable(singleCustomer)}
                      >
                        <td style={{ display: "flex" }}>
                          {singleCustomer.name}
                        </td>
                        <td>{singleCustomer.open}</td>
                        <td>{singleCustomer.close}</td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
              <Pagination
                nPages={nPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
              <ShowTicketsForCustomer
                show={ticketmodalShow}
                onHide={() => setTicketModalShow(false)}
                _id={customerId}
                ticketList={ticketListforUser}
              />
            </Table>
          </>
        ) : (
          <Row style={{ justifyContent: "center" }}>
            <div id="dashboardCards">
              <Col>
                <Card id="dashboardCard" border="dark">
                  <Card.Body>
                    <Card.Title>Total tickets:</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      Total Log Count
                    </Card.Subtitle>
                    <Card.Text>{totalTickets}</Card.Text>
                  </Card.Body>
                </Card>
                <Card id="dashboardCard" border="dark">
                  <Card.Body>
                    <Card.Title>Pending tickets:</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                      Unresolved
                    </Card.Subtitle>
                    <Card.Text>{pendingTickets.length}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card id="dashboardCard" border="dark">
                  <Card.Body>
                    <Card.Title>Add New Ticket:</Card.Title>

                    <Card.Text>
                      <Link to="/add-ticket">
                        {" "}
                        <Button
                          variant="outline-light"
                          style={{ float: "right", paddingBottom: "5px" }}
                        >
                          {"  "}Add
                        </Button>
                      </Link>
                    </Card.Text>
                  </Card.Body>
                </Card>
                <Card id="dashboardCard" border="dark">
                  <Card.Body>
                    <Card.Title>View Ticket table:</Card.Title>

                    <Card.Text>
                      <Button
                        onClick={() => setModalShow(true)}
                        variant="outline-light"
                        style={{ float: "right" }}
                      >
                        {"  "} View
                      </Button>

                      <TicketModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                      />
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </div>
          </Row>
        )}
      </Container>
    </>
  );
};
